import AdminEventsList from './eventsList';

export default AdminEventsList;
